import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FeedbackService } from '../manik-library/FeedbackService';

@Component({
  selector: 'app-ecomm-order-handle',
  templateUrl: './ecomm-order-handle.component.html',
  styleUrls: ['./ecomm-order-handle.component.css']
})
export class EcommOrderHandleComponent implements OnInit {

  paramData: any = {};
  companyData: any = {};
  feedbackSubmit: boolean = false;
  rating: any = '0.0';
  checkboxList: any = [];
  comments: any = '';
  files: any;
  filesStoredUrl: any = [];
  staffList: any = [];
  FeedbackForm!: FormGroup;
  isLoggedInVar = false;
  @ViewChild('myloginModal') myloginModal: any | undefined;

  constructor(
    private activatedRoute: ActivatedRoute,
    private feedbackService: FeedbackService,
    private formBuilder: FormBuilder,
    private title: Title
  ) { }

  ngOnInit(): void {
    this.title.setTitle("Order Feedback");
    this.FeedbackForm = this.formBuilder.group({
      Email: ['', [Validators.required, Validators.email]],
      Name: ['', [Validators.required]],
      Phone: ['', [Validators.required]],
    });

    this.activatedRoute.params.subscribe(success => {
      this.paramData = success;
    });
    const headers = new HttpHeaders({
      TenantID: 'INSTA.WEB',
    });
    this.feedbackService.getToken(headers).subscribe((data) => {
      let Authorization = data['ManikJSon'][0]['JSon0'];
      sessionStorage.setItem('sToken', Authorization);
      this.getData();
    });
  }

  getData() {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      'Content-Type': 'application/json',
      EntityActionType: "FETCH.ECOMM.ORDER.FEEDBACK.JSON",
      OrderHandle: this.paramData.section,
      ECommDS: this.paramData.businessslug
    });
    this.feedbackService.getEcomOrderData(headers).subscribe((data) => {
      this.companyData = data['ManikJSon'][0]['JSon0'][0];
      this.checkboxList = data['ManikJSon'][0]['JSon2']?.map((i) => {
        i.checked = false;
        return i;
      });
      this.staffList = data['ManikJSon'][0]['JSon1'];
      
    });
  }

  toggleCheckbox(i) {
    this.checkboxList[i].checked != this.checkboxList[i].checked;
  }

  previewImages = async (event) => {
    this.files = event.target.files;
    let htmlTemp = '';
    document.getElementById('image_preview').innerHTML;
    for (var i = 0; i < this.files.length; i++) {
      htmlTemp =
        htmlTemp +
        '<div class="col-md-3 mt-3 img-preview">' +
        '<div class="card border-0">' +
        '<img class="card-img" src="' +
        URL.createObjectURL(this.files[i]) +
        '" alt="Card image">' +
        '<div class="card-img-overlay image-cross-icon p-0">' +
        '<button type="button" class="close" aria-label="Close">' +
        `<span aria-hidden="true"><img (click)="onRemovePhoto(1)" src="../../../assets/images/cancel.svg" class="img-fluid"></span>` +
        '</button>' +
        '</div>' +
        '</div>' +
        '</div>';
    }
    document.getElementById('image_preview').innerHTML = htmlTemp;
    for (var i = 0; i < this.files.length; i++) {
      let pr = await this.uploadImageNew(this.files[i]);
      this.filesStoredUrl.push(pr);
    }
  }

  uploadImageNew = (file) => {
    return new Promise((res, rej) => {
      var formdata = new FormData();
      formdata.append(file.name, file);
      let config = {
        headers: {
          'FolderPath': 'http://resources.manikworks.com/',
          'Content-Type': 'application/x-www-form-urlencoded',
          'FileName': file.name
        }
      }
      this.feedbackService.uploadImage("https://imagehandler.manikworks.com", formdata, config).then((data) => {
        res(data.data["ManikJSon"][0]["JSon0"][0]["DocURL"]);
      })
    })
  }

  deleteMe(id: string) {
    this.staffList.map(x => x.isSelected = false);
    this.staffList.find(x => x.id === id).isSelected = true;
  }

  onSubmit() {
    // console.log("this.filesStoredUrl", this.filesStoredUrl, this.isLoggedInVar);

    if (this.isLoggedInVar) {
      let obj: any = {
        items: [
          {
            StarRating: parseInt(this.rating),
            BusinessHandle: "",
            ECommBranchID: '',
            CitizenHandle: "",
            SelectedParams: [],
            SelectedParamNames: [],
            Review: this.comments,
            Email: this.FeedbackForm.controls['Email'].value,
            Name: this.FeedbackForm.controls['Name'].value,
            Phone: this.FeedbackForm.controls['Phone'].value,
            StaffID: '0',
            OrderHandle: this.paramData.orderHandle
          }
        ],
      };
      this.checkboxList.forEach((element: any) => {
        if (element.checked) {
          obj["items"][0]["SelectedParams"].push(element.RatingParamID);
          obj["items"][0]["SelectedParamNames"].push(element.RatingParameter);
        }
      });
      obj["items"][0]["SelectedParams"] = obj["items"][0]["SelectedParams"].join(',');
      obj["items"][0]["SelectedParamNames"] = obj["items"][0]["SelectedParamNames"].join(',');
      let config = {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
          'Content-Type': 'application/json',
          'Context': 'SUBMIT.REVIEW',
          'PortalDS': this.companyData['PortalDS']
        }
      }
      this.feedbackService.addProfile(obj, config).then(res => {
        try {
          if (this.filesStoredUrl.length) {
            let ReviewID = JSON.parse(res["data"]["STATUS"])["ManikJSon"][0]["JSon0"][0]["NewEntity"]
            let obj: any = {
              "items": []
            };
            this.filesStoredUrl.forEach(p => {
              obj["items"].push({
                "ReviewID": ReviewID,
                "MediaType": "I",
                "MediaURL": p
              })
            })
            let config = {
              headers: {
                Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
                'Content-Type': 'application/json',
                Context: 'SUBMIT.REVIEW.MEDIA',
                PortalDS: this.companyData['PortalDS']
              }
            }
            this.feedbackService.addProfile(obj, config).then(res => {
              this.feedbackSubmit = true;
            })
          } else {
            this.feedbackSubmit = true;
          }
        } catch (e) {
          this.feedbackSubmit = true;
        }
      })
    } else {
      this.myloginModal.nativeElement.click();
    }
  }

}
